import React from "react";
import { Box, Link, Typography, useTheme } from "@mui/material";
import { useNavigate, useMatches, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowCircleLeft } from "@mui/icons-material";
import { buildTestId, getRouteSection } from "@utils/utilsTestIds";
import { useSidebarLandingItem } from "@context/sidebarLayout";

interface PROPS {
  customRedirect?: any;
  goBack?: number;
  customNavigate?: any;
}

const ButtonBackPage: React.FC<PROPS> = ({
  customRedirect,
  goBack = 1,
  customNavigate,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const matches = useMatches();
  const location = useLocation();
  const { t } = useTranslation(["common"]);
  const findPathIndex = matches.findIndex(
    (el) => el.pathname === location.pathname,
  );
  const { area, section } = getRouteSection(location.pathname);
  const landingItem = useSidebarLandingItem();

  if (landingItem) return null;

  return (
    <Box>
      <Link
        component="button"
        type="button"
        id={buildTestId(area, section, "back-button")}
        data-testid={buildTestId(area, section, "navigation-back")}
        aria-label={t("backButtonAriaLabel")}
        sx={{
          color: theme.palette.text.primary,
          display: "flex",
          alignItems: "center",
          gap: "8px",
          mb: "24px",
          "&:hover": {
            textDecoration: "underline",
          },
        }}
        onClick={() => {
          if (customNavigate) {
            customNavigate();
          } else {
            navigate(
              customRedirect
                ? customRedirect
                : matches[findPathIndex - goBack].pathname,
            );
          }
        }}
      >
        <ArrowCircleLeft sx={{ fontSize: "32px" }} />
        <Typography sx={{ fontWeight: "600" }}>{t("backButton")}</Typography>
      </Link>
    </Box>
  );
};

export default ButtonBackPage;
